import { render, staticRenderFns } from "./baodxz_config.vue?vue&type=template&id=1bec7993&scoped=true&"
import script from "./baodxz_config.vue?vue&type=script&lang=js&"
export * from "./baodxz_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bec7993",
  null
  
)

export default component.exports